/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import axios from 'axios';

const socialConfig = window.socialConfig || {};
const { access_token_properties: accessTokenProperties = {} } = socialConfig;

let {
  access_token,
  refresh_token,
  expires_in,
  created_at,
} = accessTokenProperties;

let expires_at = created_at + expires_in;

const fetchSocialToken = async ({ isRefresh }) => {
  const url = isRefresh
    ? `/social/refresh_token?refresh_token=${refresh_token}`
    : '/social/access_token';
  const response = await (await fetch(url)).json();
  ({
    access_token,
    refresh_token,
    expires_in,
    created_at,
  } = response);
  expires_at = created_at + expires_in;
};

const handleUseSocialToken = async (config) => {
  // Ensure headers object exists
  config.headers = config.headers || {};

  const baseUrl = config.baseURL || '';
  const url = config.url || '';
  const fullUrl = baseUrl + url;

  const shouldUseToken = fullUrl.includes('intellumsocial.com') || fullUrl.includes('tribe');

  if (shouldUseToken) {
    if (!expires_at) {
      await fetchSocialToken({ isRefresh: false });
    }

    const currentTime = Math.floor(Date.now() / 1000);
    if (refresh_token && currentTime > expires_at) {
      await fetchSocialToken({ isRefresh: true });
    }

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
  }

  const isGCSCall = url.includes('storage.googleapis.com');
  const isS3Call = url.includes('s3.amazonaws.com');

  if (isGCSCall || isS3Call) {
    const src = config.headers || {};
    const toObj =
      src && typeof src.toJSON === 'function' ? src.toJSON() : src;

    const cleaned = Object.entries(toObj || {}).reduce((acc, [k, v]) => {
      const lower = String(k).toLowerCase();
      if (lower === 'authorization' || lower === 'x-csrf-token') return acc;
      acc[k] = v;
      return acc;
    }, {});

    config.headers = axios?.AxiosHeaders
      ? axios.AxiosHeaders.from(cleaned)
      : cleaned;
  }

  return config;
};

export default () => {
  const tokenEl = document.querySelector('[name=csrf-token]');
  const token = tokenEl ? tokenEl.content : null;
  if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
  }

  axios.interceptors.request.use(handleUseSocialToken, (err) =>
    Promise.reject(err)
  );
};
